
import { createStore } from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import moduleLayout from "./modules/layout.js"
import moduleCategories from './modules/categories.js'
import moduleProducts from './modules/products.js'
import moduleUsers from './modules/users.js'
import moduleActivity from "./modules/activity.js"
import moduleOrders from './modules/orders.js'
import moduleReviews from "./modules/reviews.js"

const store = createStore({
    state,
    actions,
    getters,
    mutations,
    modules: {
        layout: moduleLayout,
        categoryList: moduleCategories,
        productList: moduleProducts,
        userList: moduleUsers,
        activity: moduleActivity,
        orderList: moduleOrders,
        reviewList: moduleReviews
    },
    strict: process.env.NODE_ENV !== 'production',
})

export default store
